import React from "react";
import { useSelector } from "react-redux";
import {
    findProductFromProductId,
    getIndexOfItemAlreadyInStoreCart,
} from "@qgiv/p2p-registration";
import { useFormikContext } from "formik";
import { selectAllRegistration } from "../../../../redux/slices/registrationSlice";
import {
    selectAllProductModal,
    updateCurrentStoreCartItemIndex,
} from "../../../../redux/slices/productModalSlice";
import { selectAllProducts } from "../../../../redux/slices/productsSlice";
import UpdateProductDetails from "./UpdateProductDetails";

const ConnectedUpdateProductDetails = () => {
    const { values, setFieldValue } = useFormikContext();
    const { Product_Id, Field_Data_Id = "" } = values;

    const { storeCart = [] } = useSelector(selectAllRegistration);
    const {
        modalAccessedFromStoreList = false,
        originalStoreCartItemIndex = -1,
    } = useSelector(selectAllProductModal);
    const products = useSelector(selectAllProducts);

    const currentProductInfo = products
        ? findProductFromProductId(Product_Id, products)
        : {};

    const indexOfItemAlreadyInStoreCart = getIndexOfItemAlreadyInStoreCart(
        storeCart,
        currentProductInfo,
        Field_Data_Id,
        Product_Id,
    );

    const updateProductDetailsProps = {
        originalStoreCartItemIndex,
        indexOfItemAlreadyInStoreCart,
        modalAccessedFromStoreList,
        setFieldValue,
        storeCart,
        // Action
        updateCurrentStoreCartItemIndex,
    };
    return <UpdateProductDetails {...updateProductDetailsProps} />;
};

export default ConnectedUpdateProductDetails;
